import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const API_URL = (getApiBaseUrl()).replace(/\/+$/, '')
const API_KEY = getApiKey()

const authHeaders = () => {
    const token = localStorage.getItem('accessToken')
    return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
}

const parseQuery = (url = '') => {
    const parts = String(url).split('?')
    return parts.length > 1 ? parts[1] : ''
}

const parsePayload = (config) => {
    try {
        return JSON.parse(config?.data || '{}')
    } catch (e) {
        console.error('cashbox parsePayload error', e)
        return {}
    }
}

const withApiKey = (path, query = '') => {
    const cleanPath = String(path || '').startsWith('/') ? path : `/${path}`
    const sep = query ? `&${query}` : ''
    return `${API_URL}${cleanPath}?apiKey=${API_KEY}${sep}`
}

const toProxyError = (err, fallbackText) => {
    const status = Number(err?.response?.status) || 500
    const responseData = err?.response?.data
    if (responseData && typeof responseData === 'object') {
        return [status, responseData]
    }
    const message = responseData || err?.message || fallbackText
    return [status, { message: String(message) }]
}

const proxyGet = async (remotePath, config, fallbackText) => {
    try {
        const query = parseQuery(config?.url)
        const res = await axios.get(withApiKey(remotePath, query), authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return toProxyError(err, fallbackText)
    }
}

const proxyPost = async (remotePath, config, fallbackText) => {
    try {
        const payload = parsePayload(config)
        const query = parseQuery(config?.url)
        const res = await axios.post(withApiKey(remotePath, query), payload, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return toProxyError(err, fallbackText)
    }
}

const proxyPutAsPost = async (remotePath, config, fallbackText) => {
    try {
        const payload = parsePayload(config)
        const query = parseQuery(config?.url)
        const res = await axios.post(withApiKey(remotePath, query), payload, authHeaders())
        return [res?.status || 200, res?.data || {}]
    } catch (err) {
        console.error(err)
        return toProxyError(err, fallbackText)
    }
}

Mock.onGet('/api/cashbox/settings').reply((config) =>
    proxyGet('/cashbox/settings/get/', config, 'Ошибка загрузки настроек кассы'),
)

Mock.onGet('/api/cashbox/settings/get').reply((config) =>
    proxyGet('/cashbox/settings/get/', config, 'Ошибка загрузки настроек кассы'),
)

Mock.onPut('/api/cashbox/settings').reply((config) =>
    proxyPutAsPost('/cashbox/settings/save/', config, 'Ошибка сохранения настроек кассы'),
)

Mock.onPost('/api/cashbox/settings/save').reply((config) =>
    proxyPost('/cashbox/settings/save/', config, 'Ошибка сохранения настроек кассы'),
)

Mock.onGet(/\/api\/cashbox\/state(?:\?.*)?$/).reply((config) =>
    proxyGet('/cashbox/state/get/', config, 'Ошибка загрузки состояния кассы'),
)

Mock.onGet(/\/api\/cashbox\/operations(?:\?.*)?$/).reply((config) =>
    proxyGet('/cashbox/operations/get/', config, 'Ошибка загрузки операций кассы'),
)

Mock.onGet('/api/cashbox/operations/get').reply((config) =>
    proxyGet('/cashbox/operations/get/', config, 'Ошибка загрузки операций кассы'),
)

Mock.onGet(/\/api\/cashbox\/shifts\/history(?:\?.*)?$/).reply((config) =>
    proxyGet('/cashbox/shifts/history/', config, 'Ошибка загрузки истории смен'),
)

Mock.onPost('/api/cashbox/shifts/open').reply((config) =>
    proxyPost('/cashbox/shifts/open/', config, 'Ошибка открытия смены'),
)

Mock.onPost('/api/cashbox/shifts/close').reply((config) =>
    proxyPost('/cashbox/shifts/close/', config, 'Ошибка закрытия смены'),
)

Mock.onPost('/api/cashbox/operations').reply((config) =>
    proxyPost('/cashbox/operations/add/', config, 'Ошибка сохранения операции'),
)

Mock.onPost('/api/cashbox/operations/reverse').reply((config) =>
    proxyPost('/cashbox/operations/reverse/', config, 'Ошибка сторно операции'),
)

Mock.onPost('/api/cashbox/refund/order').reply((config) =>
    proxyPost('/cashbox/refund/order/', config, 'Ошибка возврата по заказу'),
)
